import React from 'react'

export default function Tinglovchilar() {
  return (
    <div>Tinglovchilar</div>
  )
}
